import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';
import { Resource, ResourceEditor } from '../containers/index';
import './styles/ResourceTable.css';

const propTypes = {
  resources: PropTypes.arrayOf(PropTypes.object).isRequired,
  resourceEditorOpen: PropTypes.bool.isRequired,
};

const ResourceTable = ({ resources, resourceEditorOpen }) => (
  <div id="resource-table">
    <Loader active={resources.length === 0} />
    {resourceEditorOpen ? <ResourceEditor /> : null}
    {resources ? resources.map((resource, index) => (
      <Resource
        resource={resource}
        index={index}
        key={resource._id}
        clientMode={false}
      />
    )) : ''}
  </div>
);

ResourceTable.propTypes = propTypes;

export default ResourceTable;



// WEBPACK FOOTER //
// ./src/components/ResourceTable.jsx